// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TixGZ","left":"styles_left__16gle","right":"styles_right__c685T","alert":"styles_alert__1wtok"};